import React, { useRef, useEffect } from "react";
import styles from "./Composer.module.css";
import { DataPills } from "./DataPills";
import { useComposer } from "../context/ComposerContext";

interface InputAreaProps {
  input: string;
  handleInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit: (
    event:
      | React.KeyboardEvent<HTMLTextAreaElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => void;
  status: string;
  stop: () => void;
  showDataPills?: boolean;
}

export const InputArea: React.FC<InputAreaProps> = ({
  input,
  handleInputChange,
  handleSubmit,
  status,
  stop,
  showDataPills = false,
}) => {
  const { additionalData, placeholderText } = useComposer();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const autoResizeTextarea = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    autoResizeTextarea();
  }, [input]);

  return (
    <div className={styles.inputContainer}>
      {showDataPills && <DataPills data={additionalData} />}
      <textarea
        ref={textareaRef}
        value={input}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
          }
        }}
        className={styles.inputField}
        placeholder={placeholderText}
        disabled={status !== "ready"}
      />
      {status === "ready" ? (
        <button
          onClick={(e) => void handleSubmit(e)}
          className={styles.sendButton}
          disabled={status !== "ready"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M16.4944 8.23732L1.3877 1.08398L2.47436 7.24398L6.74103 9.25065V7.77732L3.6677 6.33065L3.1477 3.39065L13.381 8.23732L3.1477 13.084L3.8077 9.34398L2.55436 8.75732L1.3877 15.3907L16.4944 8.23732Z"
              fill="#B5B2AA"
            />
          </svg>
        </button>
      ) : (
        <button onClick={stop} className={styles.stopButton}>
          stop
        </button>
      )}
    </div>
  );
};
